export const SET_STEP = 'SET_STEP';
export const ADD_TO_MULTI_FORM = 'ADD_TO_MULTI_FORM';
export const REMOVE_FROM_MULTI_FORM = 'REMOVE_FROM_MULTI_FORM';
export const CLEAR_MULTI_FORM = 'CLEAR_MULTI_FORM';
export const SUBMIT_MULTI_FORM_START = 'SUBMIT_MULTI_FORM_START';
export const SUBMIT_MULTI_FORM_SUCCESS = 'SUBMIT_MULTI_FORM_SUCCESS';
export const SUBMIT_MULTI_FORM_FAIL = 'SUBMIT_MULTI_FORM_FAIL';
export const SET_FORM = 'SET_FORM';
export const CLEAR_FORM = 'CLEAR_FORM';
